import React, { useState, useEffect } from 'react';

const Tab = ({ icon, label, isActive, onClick }: any) => (
    <button
        className={`flex-1 flex items-center justify-center gap-1.5 py-3 text-sm font-medium border-b-2 transition-colors
            ${isActive
                ? 'border-[#12AB81] text-[#12AB81] bg-green-50/60'
                : 'border-transparent text-gray-400'
            }`}
        onClick={onClick}
    >
        <span className={`text-base ${isActive ? 'text-[#12AB81]' : 'text-gray-400'}`}>{icon}</span>
        <span>{label}</span>
    </button>
);

const Tabs = ({ items = [] }: any) => {
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        if (activeTab >= items.length) setActiveTab(0);
    }, [items, activeTab]);

    return (
        <div className="w-full">
            <div className="flex bg-white border-b border-gray-200">
                {items?.map((tab: any, index: number) => (
                    <Tab
                        key={tab.id ?? index}
                        icon={tab.icon}
                        label={tab.label}
                        isActive={index === activeTab}
                        onClick={() => setActiveTab(index)}
                    />
                ))}
            </div>
            <div className="pt-3">
                {items[activeTab]?.content}
            </div>
        </div>
    );
};

export default Tabs;
